<span [class]="computedClasses()" [innerHTML]="iconSvg()" role="img" [attr.aria-label]="name"></span>
